(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8930],{

/***/ 78930:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ TravelSliderBanner_TravelSliderBanner; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./src/components/models/travel/sliders/TravelDefaultSlider/TravelDefaultSlider.module.scss
var TravelDefaultSlider_module = __webpack_require__(69808);
var TravelDefaultSlider_module_default = /*#__PURE__*/__webpack_require__.n(TravelDefaultSlider_module);
// EXTERNAL MODULE: ./src/components/models/travel/teasers/TravelInfoTeaser/TravelInfoTeaser.module.scss
var TravelInfoTeaser_module = __webpack_require__(78709);
var TravelInfoTeaser_module_default = /*#__PURE__*/__webpack_require__.n(TravelInfoTeaser_module);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Card.js + 2 modules
var Card = __webpack_require__(78182);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 17 modules
var esm = __webpack_require__(66290);
// EXTERNAL MODULE: ./src/components/elements/media/CloudinaryImage/index.ts + 1 modules
var CloudinaryImage = __webpack_require__(6498);
// EXTERNAL MODULE: ./src/lib/helpers/helpers.ts
var helpers = __webpack_require__(15778);
// EXTERNAL MODULE: ./src/lib/helpers/travel.ts
var helpers_travel = __webpack_require__(87086);
// EXTERNAL MODULE: ./src/themes/kultour/components/elements/buttons/CardButton/index.tsx + 1 modules
var CardButton = __webpack_require__(70974);
;// CONCATENATED MODULE: ./src/components/models/travel/teasers/TravelInfoTeaser/TravelInfoTeaser.tsx









var TravelInfoTeaser = function(param) {
    var travel = param.travel, trackingStringPrefix = param.trackingStringPrefix;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
            className: (TravelInfoTeaser_module_default()).card + " an-up",
            "data-tr-view": "".concat(trackingStringPrefix, "_travel_teaser:view"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/tour/".concat(travel.urlSlug),
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "img-ratio-16-9",
                        "data-tr-click": "".concat(trackingStringPrefix, "_travel_teaser:click"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloudinaryImage/* default */.Z, {
                            image: travel.mainImage,
                            aspectRatio: 1.777,
                            width: 750,
                            responsive: false,
                            lazyload: true,
                            placeholder: true,
                            altDefault: travel.name,
                            className: "card-img",
                            placeholderClassName: "position-absolute"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Body */.Z.Body, {
                    className: (TravelInfoTeaser_module_default()).body,
                    "data-tr-click": "".concat(trackingStringPrefix, "_teaser_text:click_wrong"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                                xs: 12,
                                className: (TravelInfoTeaser_module_default()).mainInfo,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default.Title */.Z.Title, {
                                        className: (TravelInfoTeaser_module_default()).title,
                                        children: travel.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default.Text */.Z.Text, {
                                        as: "div",
                                        className: (TravelInfoTeaser_module_default()).text,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (TravelInfoTeaser_module_default()).date,
                                                children: (0,helpers_travel/* buildFilterTravelDatesLabel */.KP)(travel, t)
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (TravelInfoTeaser_module_default()).tourGuide,
                                                children: travel.travelGuides[0] ? "".concat(t("with"), " ").concat(travel.travelGuides[0].fullName) : ""
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (TravelInfoTeaser_module_default()).price,
                                                children: "".concat(t("booking.priceFrom"), " ").concat((0,helpers/* formatPrice */.T4)(travel.minPrice, travel.currency))
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                className: (TravelInfoTeaser_module_default()).highlights,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    children: travel.highlights.map(function(highlight, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: highlight.text
                                        }, index);
                                    })
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CardButton/* default */.Z, {
                    label: t("furtherInformation"),
                    href: "/tour/".concat(travel.urlSlug),
                    className: (TravelInfoTeaser_module_default()).linkBtn
                })
            ]
        })
    });
};
/* harmony default export */ var TravelInfoTeaser_TravelInfoTeaser = (TravelInfoTeaser);

;// CONCATENATED MODULE: ./src/components/models/travel/teasers/TravelInfoTeaser/index.tsx


// EXTERNAL MODULE: ./src/components/elements/sliders/SliderWithDots/index.tsx + 5 modules
var SliderWithDots = __webpack_require__(70045);
;// CONCATENATED MODULE: ./src/components/models/travel/sliders/TravelDefaultSlider/TravelDefaultSlider.tsx





var TravelDefaultSlider = function(param) {
    var travels = param.travels, _sliderOptions = param.sliderOptions, sliderOptions = _sliderOptions === void 0 ? {} : _sliderOptions;
    var sliderDefaultOptions = {
        loop: true,
        skipSnaps: true,
        containScroll: "trimSnaps"
    };
    sliderOptions = (0,_object_spread/* default */.Z)({}, sliderDefaultOptions, sliderOptions);
    var getSlides = function(travels) {
        var slides = [];
        travels.map(function(travel, index) {
            var slide = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (TravelDefaultSlider_module_default()).slideWrap,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (TravelDefaultSlider_module_default()).slideInner,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TravelInfoTeaser_TravelInfoTeaser, {
                        travel: travel,
                        trackingStringPrefix: "travel_page:bestseller_slider"
                    })
                })
            }, index);
            slides.push(slide);
        });
        return slides;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderWithDots/* default */.Z, {
            slides: getSlides(travels),
            options: sliderOptions,
            autoplay: 4000,
            trackingStringPrefix: "travel_page:bestseller_slider"
        })
    });
};
/* harmony default export */ var TravelDefaultSlider_TravelDefaultSlider = (TravelDefaultSlider);

;// CONCATENATED MODULE: ./src/components/models/travel/sliders/TravelDefaultSlider/index.tsx


// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./src/components/cms/Title/index.tsx + 1 modules
var Title = __webpack_require__(2736);
;// CONCATENATED MODULE: ./src/components/models/travel/sliders/TravelSliderBanner/TravelSliderBanner.tsx




var TravelSliderBanner = function(param) {
    var title = param.title, travels = param.travels, _sliderOptions = param.sliderOptions, sliderOptions = _sliderOptions === void 0 ? {} : _sliderOptions;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            fluid: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Col/* default */.Z, {
                    className: "p-0 mb-5",
                    children: [
                        title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* TitleH2 */.W, {
                                        title: title,
                                        mb: 0
                                    })
                                })
                            })
                        }),
                        travels.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(TravelDefaultSlider_TravelDefaultSlider, {
                            travels: travels,
                            sliderOptions: sliderOptions
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var TravelSliderBanner_TravelSliderBanner = (TravelSliderBanner);

;// CONCATENATED MODULE: ./src/components/models/travel/sliders/TravelSliderBanner/index.ts



/***/ }),

/***/ 70974:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ CardButton_CardButton; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/elements/buttons/CustomButton/index.tsx + 1 modules
var CustomButton = __webpack_require__(10926);
;// CONCATENATED MODULE: ./src/themes/kultour/components/elements/buttons/CardButton/CardButton.tsx



var CardButton = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomButton/* default */.Z, (0,_object_spread/* default */.Z)({}, props));
};
/* harmony default export */ var CardButton_CardButton = (CardButton);

;// CONCATENATED MODULE: ./src/themes/kultour/components/elements/buttons/CardButton/index.tsx



/***/ }),

/***/ 69808:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"slideWrap":"TravelDefaultSlider_slideWrap__zF49U","slideInner":"TravelDefaultSlider_slideInner__6WbrZ"};

/***/ }),

/***/ 78709:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrap":"TravelInfoTeaser_wrap__XdpNI","card":"TravelInfoTeaser_card__W__p_","body":"TravelInfoTeaser_body__oSBqY","mainInfo":"TravelInfoTeaser_mainInfo__GCjIq","title":"TravelInfoTeaser_title__DH0Vj","text":"TravelInfoTeaser_text__0bXtS","date":"TravelInfoTeaser_date__ihGcs","tourGuide":"TravelInfoTeaser_tourGuide__IGTR3","price":"TravelInfoTeaser_price__12_Hq","highlights":"TravelInfoTeaser_highlights__7SmFy","linkBtn":"TravelInfoTeaser_linkBtn__lQ3NA"};

/***/ })

}]);